// src/graphql/queries/engagementQueries.js
// Engagement campaigns: composer data (campaigns, per-user preview) + ledger

const recipientFields = `
        userId
        email
        firstName
        lastName
        companyName
        tier
        status
        lastLogin
        lastSentAt
        skip
        data`;

export const getEngagementCampaigns = () => `query GetEngagementCampaigns {
    adminEngagementCampaigns { template label content cooldownDays answers }
}`;

export const getEngagementPreview = () => `query GetEngagementPreview($template: String!, $userIds: [String!], $content: EngagementContentInput) {
    adminEngagementPreview(template: $template, userIds: $userIds, content: $content) {${recipientFields}
    }
}`;

export const getEngagementSends = () => `query GetEngagementSends($template: String, $limit: Int) {
    adminEngagementSends(template: $template, limit: $limit) {
        id userId template recipient jobId answer feedback answeredAt respondBy sentAt
    }
}`;

export { recipientFields as engagementRecipientFields };
